export const DEFAULT_YEAR = 2025;
export const YEARS = [2025, 2024, 2023, 2022, 2021];

export const DEFAULT_DIVISION = 3;
export const DIVISIONS = [1, 2, 3];
export const DIVISION_LABELS = {
  1: 'D1',
  2: 'D2', 
  3: 'D3',
};

export const TEAM_FALLBACK = "https://d3-dashboard-kellyjc.s3.us-east-2.amazonaws.com/images/0.png";
export const PLAYER_HEADSHOT_FALLBACK = "https://d3-dashboard-kellyjc.s3.us-east-2.amazonaws.com/images/default-silhouette.png";